import { Ability, AbilityBuilder } from "@casl/ability"

export const getAbilities = user => {
  const { can, rules } = new AbilityBuilder(Ability)
  if (user) {
    if (user.perfil === 'Administrador' || user.perfil === 'Desenvolvedor') {
      can('view', 'all')
      can('cadastro-pacientes', 'Cadastro')
      can('cadastro-usuarios', 'Cadastro')
    } else if (user.perfil === 'Supervisor') {
      can('view', 'Default')
      can('cadastro-usuarios', 'Cadastro')
      can('cadastro-pacientes', 'Cadastro')
      can('view', 'Autorizacao')
      can('view', 'Execucao')
      can('view', 'Historico')
      can('view', 'Pendencias')
      can('view', 'Pedidos de Exame')
      can('view', 'Anexo Guia')
      can('view', 'Biometria Guia')
      can('view', 'Token Guia')
      can('view', 'Assinatura Guia')
      can('view', 'Ivia')
    } else if (user.perfil === 'Recepção') {
      can('view', 'Default')
      can('cadastro-pacientes', 'Cadastro')
      can('view', 'Autorizacao')
      can('view', 'Execucao')
      can('view', 'Historico')
      can('view', 'Pendencias')
      can('view', 'Pedidos de Exame')
      can('view', 'Anexo Guia')
      can('view', 'Biometria Guia')
      can('view', 'Token Guia')
      can('view', 'Assinatura Guia')
      can('view', 'Ivia')
    } else if (user.perfil === 'Faturamento') {
      can('view', 'Default')
      can('view', 'Faturamento')
      can('view', 'Historico')
      can('view', 'Relatorios')
    } else if (user.perfil === 'Default') {
      can('view', 'Default')
    }
  } else {
    can('view', 'Auth')
    can('view', 'Envio Pedido')
    can('view', 'Envio Anexo')
  }

  return rules
}
